import { IFootballConfig, ITwoTeamsH2H } from '../../../../packages/types';
import { normalizeFootballTeam } from './normalizeFootballTeam';

interface INormalizeFootballTeamsDataArgs {
  teams?: ITwoTeamsH2H | null;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
}

export const normalizeFootballTeams = ({ teams, dataEntityLinks, dataTeamNameType }: INormalizeFootballTeamsDataArgs) => {
  if (!teams) return;

  return {
    firstTeam: normalizeFootballTeam({ team: teams?.firstTeam, dataEntityLinks, dataTeamNameType }),
    secondTeam: normalizeFootballTeam({ team: teams?.secondTeam, dataEntityLinks, dataTeamNameType }),
  };
};
